import AuthLayout from "../Layout/AuthLayout";
import Signin from "../pages/Auth/Signin";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import OTPverify from "../pages/Auth/OtpVerify";
import ResetPassword from "../pages/Auth/ResetPassword";
import Dashboard from "../pages/Main/Dashboard";

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  element: <AuthLayout />,
  children: [
    {
      path: "/",
      element: <Signin />,
    },
    {
      path: "/ForgetPassword",
      element: <ForgotPassword />,
    },
    {
      path: "/OTPverify",
      element: <OTPverify />,
    },
    {
      path: "/ResetPassword",
      element: <ResetPassword />,
    },
  ],
};

export default LoginRoutes;
